
import React from "react";
import { UseQueryResult } from "react-query";

import { ISearchResultItem, Post } from '../../common/entities'
import Spinner from '../Spinner';
import PostSearcherResultsItem from './PostSearcherResultsItem';
import styles from './PostSearcherResults.module.scss';

function PostSearcherResults({posts, results, onSelect}: {posts: Post[]; results: UseQueryResult; onSelect: (name: Post) => void; }) {
  const { status, data, error } = results;

  let inside

  if (status === "loading") {
    inside = <div className={styles.spinnerContainer}><Spinner /></div>;
  }

  if (status === "error") {
    inside = error instanceof Error ? <span className={styles.error}>Error: {error.message}</span> : null;
  }
  if (status === "success" && Array.isArray(data)) {
    const filteredData = Array.isArray(posts) ? data.filter((result: ISearchResultItem) => !posts.map(post => post.UUID).includes(result.Self.UUID)) : data;
    if (filteredData.length > 0) {
      inside = filteredData.map((result: ISearchResultItem) => <PostSearcherResultsItem entity={result} key={result.Self.UUID} onSelect={onSelect} />)
    } else {
      inside = <span className={styles.noResults}>No results</span>;
    }
  }
  return (
    <div className={styles.container}>
      {inside}
    </div>
  )
}

export default PostSearcherResults;
